export const TONE_PRESETS = [
  {
    key: "bold",
    label: "Bold",
    tagline: "Direct · contrarian · punchy",
    tone: "Bold and direct. Short sentences. Strong opinions. No hedging. One idea per line.",
  },
  {
    key: "analytical",
    label: "Analytical",
    tagline: "Precise · data-driven · logical",
    tone: "Analytical and precise. Uses concrete data. Structured logic. Neutral, measured tone.",
  },
  {
    key: "warm",
    label: "Warm",
    tagline: "Personal · conversational · kind",
    tone: "Warm and conversational. Uses personal anecdotes. Kind but honest. Second-person friendly.",
  },
  {
    key: "playful",
    label: "Playful",
    tagline: "Witty · irreverent · clever",
    tone: "Playful, witty, and slightly irreverent. Clever wordplay. Punchy jokes. Breaks the fourth wall.",
  },
];
